<template>
    <v-col class="my-0 py-0 px-0 px-md-10 pb-15">
        <!-- Alerta de información -->
        <v-col class="text-start mt-5 mb-3 px-0">
            <v-alert text dense color="#8061c2" border="left" class="pl-5">
                <h1 class="title mt-1">Panel</h1>
                <p class="desc mt-0 mb-1">Gráficas y estadísticas detalladas de la plataforma.</p>
            </v-alert>
        </v-col>

        <!-- Totales y Gráfica -->
        <v-col cols="12" class="px-0 py-0">
            <v-row no-gutters>
                <v-col class="col-md-6 col-12 px-0 pr-md-2">
                    <v-card cols="12" class="rounded-lg px-5 pt-4 pb-4" elevation="2">
                        <div class="d-flex">
                            <h3 class="text-left title-dashboard">Totales de ({{ selectedYear == 'Todos' ? 'Todos los años' : selectedYear }})</h3>
                            <v-progress-circular
                            v-if="loadingStatistics"
                            indeterminate
                            color="#8061c2"
                            width="2"
                            size="20"
                            class="mt-2 ml-2"
                            ></v-progress-circular>
                        </div>
                        <p class="text-left desc-dashboard mb-4">Conteo de harmonys, usuarios y ganancias.</p>
                        <v-row no-gutters>
                            <div class="col-12 col-md-4 px-md-4 pl-md-0">
                                <div class="rounded-lg d-card text-left px-4 py-1">
                                    <v-icon size="30px" color="#f9947b" class="mt-1">mdi-vector-difference-ba</v-icon>
                                    <p class="mt-2 mb-0 title-card">{{ formatNumber(totalHarmonys) }}</p>
                                    <p class="title-desc">Total Harmonys</p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 px-md-4 px-md-5 px-0 my-3 my-md-0 pl-md-0">
                                <div class="rounded-lg d-card2 text-left px-4 py-1">
                                    <v-icon size="30px" color="#40d756" class="mt-1">mdi-link-variant</v-icon>
                                    <p class="mt-2 mb-0 title-card">{{ formatNumber(totalLinks) }}</p>
                                    <p class="title-desc">Total Enlaces</p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 px-md-4 pl-md-0">
                                <div class="rounded-lg d-card3 text-left px-4 py-1">
                                    <v-icon size="30px" color="#be82fe" class="mt-1">mdi-account-group</v-icon>
                                    <p class="mt-2 mb-0 title-card">{{ formatNumber(totalUsers) }}</p>
                                    <p class="title-desc">Total Usuarios</p>
                                </div>
                            </div>

                            <div class="col-12 px-md-4 pl-md-0 pt-2 mt-2">
                                <v-row no-gutters>
                                    <div class="col-6 col-md-3 pr-1 pr-md-1 mb-2 mb-md-0">
                                        <div class="rounded-lg d-card-views1 text-left px-3 py-1">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#7986CB" class="mr-2 iconos">mdi-eye-outline</v-icon>
                                                <p class="mb-0 text-card" >{{ formatNumber(totalVisits) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Vistas Totales</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-3 pl-1 px-md-1 mb-2 mb-md-">
                                        <div class="rounded-lg d-card-views2 text-left px-3 py-1">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#F48FB1" class="mr-2 iconos">mdi-eye-check-outline</v-icon>
                                                <p class="mb-0 text-card">{{ formatNumber(totalUnique) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Vistas Únicas</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-3 pl-1 px-md-1 mb-2 mb-md-0 pl-xs-0 pr-xs-0 d-card-view">
                                        <div class="rounded-lg d-card-views3 text-left px-3 py-1">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#80DEEA" class="mr-2 iconos">mdi-cursor-default-click</v-icon>
                                                <p class="mb-0 text-card">{{ formatNumber(totalClicks) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Clics Totales</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-3 pl-1 pl-md-1">
                                        <div class="rounded-lg d-card-views4 text-left px-3 py-1">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#f9947b" class="mr-2 iconos">mdi-cursor-default-click-outline</v-icon>
                                                <p class="mb-0 text-card">{{ formatNumber(uniqueClicks) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Clics Únicos</p>
                                        </div>
                                    </div>
                                </v-row>
                            </div>

                        </v-row>
                    </v-card>
                </v-col>

                <!-- Gráfica de Vistas con Degradado -->
                <v-col class="col-md-6 col-12 px-0 pl-md-2 mt-5 mt-md-0">
                    <v-card cols="12" class="rounded-lg px-5 py-4" elevation="2">
                        <v-row justify="space-between" no-gutters>
                            <div class="mb-0">
                                <h3 class="text-left title-dashboard">Vistas de ({{ selectedYear == 'Todos' ? 'Todos los años' : selectedYear }})</h3>
                                <p class="text-left desc-dashboard mb-0">Grafica lineal de vistas.</p>
                            </div>
                            <div class="col-4 col-md-3">
                                <v-select
                                v-model="selectedYear"
                                :items="yearsList"
                                label="Datos del año"
                                class="mb-0 mb-md-4 mb-lg-0"
                                dense
                                hide-details
                                outlined
                                ></v-select>
                            </div>
                        </v-row>
                        <apexchart type="line" height="212" :options="chartOptions" :series="chartSeries" />
                    </v-card>
                </v-col>

                <v-col class="col-md-8 col-12 px-0 mt-5">
                    <v-card cols="12" class="rounded-lg px-5 py-4" elevation="2">
                        <div class="d-flex">
                            <h3 class="text-left title-dashboard">Registros de harmonys ({{ selectedYear == 'Todos' ? 'Todos los años' : selectedYear }})</h3>
                            <v-progress-circular
                                v-if="loadingAllStatistics"
                                indeterminate
                                color="#8061c2"
                                width="2"
                                size="20"
                                class="mt-2 ml-2"
                                ></v-progress-circular>
                        </div>
                        <p class="text-left desc-dashboard mb-8">
                            Graficos de registros por mes.
                        </p>
                        <apexchart type="bar" height="300" :options="groupedChartOptions"
                            :series="groupedChartSeries" />
                    </v-card>
                </v-col>

                <v-col class="col-md-4 col-12 px-0 mt-md-2 mt-0 pt-0">
                    <v-col class="col-12 px-0 pl-md-4 mt-0">
                        <v-card cols="12" class="rounded-lg px-5 py-4" elevation="2">
                            <h3 class="text-left title-dashboard ">Estadisticas geograficas de ({{ selectedYear == 'Todos' ? 'Todos los años' : selectedYear }})</h3>
                            <p class="text-left desc-dashboard  ">
                                Estadísticas de visitas por país, región y ciudad.
                            </p>


                            <v-col cols="12" class="pa-0 m">
                                <v-tabs v-model="activeTab" color="#8e84c0"
                                    class="round-tab mb-6 d-flex justify-left ml-4">
                                    <v-tab v-for="(tab, index) in tabs" :key="index" class="custom-tab ">
                                        {{ tab }}
                                    </v-tab>
                                </v-tabs>
                            </v-col>


                            <v-responsive class="scroll-data">
                                <v-data-table v-show="activeTab === 0" :headers="headersCountry" :items="countryData"
                                    :loading="loadingCountry" hide-default-footer disable-pagination>

                                    <template v-slot:item.name="{ item }">
                                        <div class="item-container">
                                            <span>{{ item.name }}</span>
                                        </div>
                                    </template>


                                    <template v-slot:item.total="{ item }">
                                        <span>{{ formatNumber(item.total) }}</span>
                                    </template>



                                    <template v-slot:item.flag="{ item }">
                                        <v-img class="flags" :src="item.flag"  loading="lazy"/>
                                    </template>

                                    <template v-slot:item.percentage="{ item }">
                                        <v-chip color="#f4e8ff">
                                            {{ item.percentage }}%
                                        </v-chip>
                                    </template>


                                </v-data-table>


                                <v-data-table v-show="activeTab === 1" :headers="headersRegion" :items="regionData"
                                    hide-default-footer disable-pagination>
                                    <template v-slot:item.total="{ item }">
                                        <span>{{ formatNumber(item.total) }}</span>
                                    </template>
                                </v-data-table>

                                <v-data-table v-show="activeTab === 2" :headers="headersCity" :items="cityData"
                                    hide-default-footer disable-pagination>
                                    <template v-slot:item.total="{ item }">
                                        <span>{{ formatNumber(item.total) }}</span>
                                    </template>
                                </v-data-table>
                            </v-responsive>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn  @click="dialog = true"   icon class="mt-1 icon-maps" color="#8061c2" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-map-search-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver todos</span>
                            </v-tooltip>
                        </v-card>
                    </v-col>
                </v-col>

                <v-col class="col-md-12 col-12 px-0 mt-5">
                    <v-card cols="12" class="rounded-lg px-5 py-4" elevation="2">
                        <div class="d-flex">
                            <h3 class="text-left title-dashboard">Registro tráfico ({{selectedYear == 'Todos' ? 'Todos los años' : selectedYear }})</h3>
                            <v-progress-circular
                                v-if="loadingAllStatistics"
                                indeterminate
                                color="#8061c2"
                                width="2"
                                size="20"
                                class="mt-2 ml-2"
                                ></v-progress-circular>
                        </div>
                        <p class="text-left desc-dashboard mb-8">
                            Tráfico por tipo de harmony
                        </p>
                        <apexchart type="bar" height="350" :options="groupedChartOptions2" :series="groupedChartSeries2"/>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
        <GeographicStatisticsAll :dialogShow.sync="dialog"   :year="selectedYear"   :activeTab="activeTab"  :tabs="tabs"   @close="dialog = false"/>
    </v-col>
</template>

<script>
import axios from '@/axios.js';
import VueApexCharts from 'vue-apexcharts';
import  { getCountryFlagUrl } from "@/utils/countries.js";
import GeographicStatisticsAll from '@/components/partials/admin/GeographicStatisticsAll.vue';

export default {
    components: {
        apexchart: VueApexCharts,
        GeographicStatisticsAll
    },
    data() {
        return {
            totalHarmonys: 0,
            totalLinks: 0,
            totalUsers: 0,
            totalViews: 0,
            totalVisits: 0,
            totalUnique: 0,
            totalClicks: 0,
            uniqueClicks: 0,
            totalUniqueViews: 0,
            countryData: [],
            regionData: [],
            cityData: [],
            activeTab: 0, // Index para la pestaña activa
            tabs: ['Países', 'Regiones', 'Ciudades'], // Las pestañas
            selectedYear: new Date().getFullYear(),
            yearsList: [],
            perPage: -1,
            loadingCountry: false,
            loadingStatistics: false,
            loadingAllStatistics: false,
            dialog: false,
            headersCountry: [
                {text: '', value: 'flag'},
                { text: 'Pais', value: 'name' },
                { text: 'Total', value: 'total' },
                { text: 'Porcentaje', value: 'percentage' },
            ],
            headersCity: [
                { text: 'Ciudad', value: 'name' },
                { text: 'Total', value: 'total' },
            ],
            headersRegion: [
                { text: 'Region', value: 'name' },
                { text: 'Total', value: 'total' },
            ],
            chartOptions: {
                chart: {
                    id: 'views-chart',
                    toolbar: { show: false },
                    animations: { enabled: true }
                },
                xaxis: {
                    categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                },
                stroke: {
                    curve: 'smooth',
                    width: 4
                },
                colors: ['#40D756', '#8061C2', '#4DBBFF', '#FFB347'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#40D756', '#8061C2'],
                        stops: [0, 100]
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                }
            },
            chartSeries: [
                {
                    name: 'Vistas Totales',
                    data: []  // Datos para vistas totales
                },
                {
                    name: 'Vistas Únicas',
                    data: []  // Datos para vistas únicas
                }
            ],
            // Opciones de la gráfica de barras agrupadas
            groupedChartOptions: {
                chart: {
                    type: 'bar',
                    stacked: false,
                    toolbar: { show: false },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                        dataLabels: {
                            position: 'top',
                        },
                    },
                },
                colors: ['#8061C2'],
                xaxis: {
                    categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    labels: {
                        style: {
                            colors: '#000',
                            fontSize: '12px'
                        }
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                },
                fill: {
                    opacity: 1,
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    markers: {
                        width: 12,
                        height: 12,
                        radius: 6,
                    }
                },
                dataLabels: {
                    enabled: false
                }
            },
            groupedChartSeries: [
                {
                    name: 'Harmonys',
                    data: [],
                },
            ],
            groupedChartOptions2:{
                chart: {
                    type: 'bar',
                    stacked: false,
                    width: '100%',
                    toolbar: { show: false },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '80%',
                        endingShape: 'rounded',
                        dataLabels: {
                            position: 'top',
                        },
                    },
                },
                colors: ['#40D756', '#8061C2', '#4DBBFF', '#FFB347'],
                xaxis: {
                    categories: ['Adultos', 'Gaming', 'Influenciadores', 'Comercio'],
                    labels: {
                        style: {
                            colors: '#000',
                            fontSize: '12px',
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    shared: true,
                    intersect: false,
                    onDatasetHover: {
                        highlightDataSeries: false
                    },
                },
                fill: {
                    opacity: 1,
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    markers: {
                        width: 12,
                        height: 12,
                        radius: 6,
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ['#000'],
                        fontSize: '12px',
                        fontFamily: 'Arial, sans-serif',
                        fontWeight: 'bold'
                    },
                    formatter: function(val, opts) {
                        const category = opts.w.globals.labels[opts.dataPointIndex];
                        if (category === 'Gaming' || category === 'Comercio') {
                            return val;
                        }
                        return '';
                    }
                },
            },
            groupedChartSeries2:[
                {
                    name: 'Total Vistas',
                    data: []
                },
                {
                    name: 'Vistas Únicas',
                    data: []
                },
                {
                    name: 'Total Clics',
                    data: []
                },
                {
                    name: 'Clics Únicos',
                    data: []
                }
            ],
        };
    },

    watch: {
        selectedYear() {
            this.fetchStatistics();
            this.fetchTotalStatistics();
            this.fetchCountryStatistics();
        }
    },
    created() {
        this.generateYearsList();
        this.fetchStatistics();
        this.fetchTotalStatistics();
        this.fetchCountryStatistics();
    },
    methods: {

        resetData (){
            this.countryData = [];
            this.regionData = [];
            this.cityData = [];
            this.groupedChartSeries = [];
            this.groupedChartSeries2= [];
            this.chartSeries = [];
            this.totalHarmonys = 0;
            this.totalLinks = 0;
            this.totalUsers = 0;
            this.totalViews = 0;
            this.totalVisits = 0;
            this.totalUnique = 0;
            this.totalClicks = 0;
            this.uniqueClicks = 0;
            this.totalUniqueViews = 0;
        },

        generateYearsList() {
            const currentYear = new Date().getFullYear();
            const startYear = 2024;
            this.yearsList = [];
            this.yearsList.push('Todos');
            for (let year = currentYear; year >= startYear; year--) {
                this.yearsList.push(year);
            }
        },

        formatNumber(value) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value);
        },

        async fetchTotalStatistics() {
            this.loadingAllStatistics = true;
            try {
                const response = await axios.get(`/admin/get-statistics-total?year=${this.selectedYear}`);
                const data = response.data;

                this.groupedChartSeries = [
                    {
                        name: 'Harmonys',
                        data: data.sites_per_month || [],
                    },
                ];

                this.loadingAllStatistics = false;

            } catch (error) {
                this.loadingAllStatistics = false;
                console.error('Error fetching total statistics:', error);
            }
        },

        async fetchStatistics() {
            this.resetData();
            this.loadingStatistics = true;
            try {
                const response = await axios.get(`/admin/get-statistics?year=${this.selectedYear}`);
                const data = response.data;
                this.totalHarmonys = data.total_sites || 0;
                this.totalLinks = data.total_links || 0;
                this.totalUsers = data.total_users || 0;
                this.totalVisits = data.total_visits || 0;
                this.totalUnique = data.unique_visits || 0;
                this.totalClicks = data.total_clicks || 0;
                this.uniqueClicks = data.unique_clicks || 0;

                const viewsArr = data.views_per_month || [];
                const uniqueViewsArr = data.unique_views_per_month || [];
                this.totalViews = viewsArr.reduce((a, b) => a + (Number(b) || 0), 0);
                this.totalUniqueViews = uniqueViewsArr.reduce((a, b) => a + (Number(b) || 0), 0);

                // Actualizar datos de la gráfica
                this.chartSeries = [
                    {
                        name: 'Vistas Totales',
                        data: data.views_per_month || []
                    },
                    {
                        name: 'Vistas Únicas',
                        data: data.unique_views_per_month || []
                    },
                    {
                        name: 'Clics Totales',
                        data: data.clicks_per_month || []
                    },
                    {
                        name: 'Clics Únicos',
                        data: data.unique_clicks_per_month || []
                    }
                ];

                const trafficData = data.traffic_creatorType || {};

                this.groupedChartSeries2 = [
                    {
                        name: 'Total Visitas',
                        data: Array.isArray(trafficData.total_visits) ? trafficData.total_visits : [0, 0, 0, 0]
                    },
                    {
                        name: 'Vistas Únicas',
                        data: Array.isArray(trafficData.unique_visits) ? trafficData.unique_visits : [0, 0, 0, 0]
                    },
                    {
                        name: 'Total Clics',
                        data: Array.isArray(trafficData.total_clicks) ? trafficData.total_clicks : [0, 0, 0, 0]
                    },
                    {
                        name: 'Clics Únicos',
                        data: Array.isArray(trafficData.unique_clicks) ? trafficData.unique_clicks : [0, 0, 0, 0]
                    }
                ];

                this.loadingStatistics = false;
            } catch (error) {
                this.loadingStatistics = false;
                console.error('Error fetching statistics:', error);
            }
        },
        async fetchCountryStatistics(){
            try {
                this.loadingCountry = true;
                const response = await axios.get(`/admin/get-statistics-country?year=${this.selectedYear}`);
                const data = response.data;

                this.countryData = Object.freeze(
                    data.visits_by_country.map(item => ({
                        name: item.normalized_country,
                        total: item.total,
                        percentage: item.percentage,
                        flag: getCountryFlagUrl(item.normalized_country)
                    }))
                );
                this.loadingCountry = false;

                this.regionData =  Object.freeze(
                    data.visits_by_region.map(item => ({
                        name: item.region,
                        total: item.total
                    }))
                );


                this.cityData = Object.freeze(
                    data.visits_by_city.map(item => ({
                        name: item.city,
                        total: item.total
                    }))
                );


            } catch (error) {
                console.error('Error fetching country statistics:', error);
            } finally {
                this.loadingCountry = false;
            }
        }
    }
};
</script>

<style scoped>

.flags {
    width: 21px !important;
}

.chip-container {
    display: flex;
    flex-wrap: wrap;  /* Permite que se dividan en múltiples filas */
    max-height: 100px; /* Ajusta esta altura si es necesario */
    overflow-x: auto;  /* Scroll horizontal */
    background-color: #f4e8ff;
    border-radius: 12px;
}

.title-desc {
    font-size: 15px;
    color: #676f7b;
}

.title-desc1 {
    font-size: 14px;
    color: #676f7b;
}

 ::v-deep .v-chip__content{
    font-weight: 800;
    color: #8e84c0;
    font-size: 10px;
    height: 18px !important;
}
::v-deep .v-chip {
    height: 15px !important;
}

.custom-tab {
    text-transform: none;
    font-size: 12px;
    font-weight: 500;
    padding: 8px 16px;
}

.scroll-data {
    height: 260px;
    overflow-y: auto;
}
.round-tab {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
.title-card {
    color: #616181;
    font-weight: 400;
    font-size: 26px;
}

.text-card{
    font-size: 18px;
    color: #616181;
    font-weight: 400;
}
.d-card {
    background-color: #fff4de;
}

.d-card2 {
    background-color: #dcfce7;
}

.d-card3 {
    background-color: #f4e8ff;
}

.d-card-views1 {
    background-color: #e6e9ff;
}

.d-card-views2 {
    background-color: #ffebf8;
}

.d-card-views3 {
    background-color: #dcf8fc;
}

.d-card-views4 {
    background-color: #fff4de;
}

.title-dashboard {
    color: #8061c2;
    font-weight: 500;
    margin-left: 10px;
    margin-top: 8px;
}

.desc-dashboard {
    color: gray;
    font-size: 14px;
    margin-left: 10px;
}

.title {
    font-size: 22px !important;
    color: #8061c2;
}

.desc {
    color: #737373;
    font-size: 15px;
}
.icon-maps {
    position: absolute;
    top: 10px;
    right: 10px;
}

@media (min-width: 1400px) and (max-width: 1600px){
    .text-card{
        font-size: 16px;
        margin-left: 5px;
    }
    .title-desc1{
        font-size: 12px;
        color: #616181;

    }
    .iconos{
        width: 10px;
        height: 10px;
    }
}

@media (min-width: 1060px) and (max-width: 1400px){
    .text-card{
        font-size: 14px;
    }
    .title-desc1{
        font-size: 13px;
    }
    .iconos{
        width: 20px;
        height: 20px;
    }
    .d-flex.align-center {
        flex-direction: column;
        text-align: left;
        align-items: flex-start !important;
        justify-content: flex-start !important;
        width: 100%;
    }

    .d-flex.align-center .mr-2 {
        margin-right: 0 !important;
        align-self: flex-start !important;
        margin-bottom: 4px;
    }
    :deep(.apexcharts-datalabels text) {
        font-size: 11px !important;
        font-weight: bold !important;
    }
}
@media (min-width: 1142px) and (max-width: 1185px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 11px !important;
        font-weight: bold !important;
    }

}
@media (min-width: 1060px ) and (max-width: 1142px){
    .text-card{
        font-size: 12px;
    }
    .title-desc1{
        font-size: 13px;
    }
    .iconos{
        width: 15px;
        height: 15px;
    }
    .d-flex.align-center {
        flex-direction: column;
        text-align: left;
        align-items: flex-start !important;
        justify-content: flex-start !important;
        width: 100%;
    }

    .d-flex.align-center .mr-2 {
        margin-right: 0 !important;
        align-self: flex-start !important;
        margin-bottom: 4px;
    }
    :deep(.apexcharts-datalabels text) {
        font-size: 10px !important;
        font-weight: bold !important;
    }
}

@media (min-width: 960px) and (max-width: 1060px){
    .text-card{
        font-size: 10.8px;
    }
    .title-desc1{
        font-size: 12px;
    }
    .iconos{
        margin-top: 5px;
        width: 15px;
        height: 15px;
    }
    .d-flex.align-center {
        flex-direction: column;
        text-align: left;
        align-items: flex-start !important;
        justify-content: flex-start !important;
        width: 100%;
    }

    .d-flex.align-center .mr-2 {
        margin-right: 0 !important;
        align-self: flex-start !important;
        margin-bottom: 4px;
    }
    :deep(.apexcharts-datalabels text) {
        font-size: 9px !important;
        font-weight: bold !important;
    }

}

@media (min-width: 750px) and (max-width: 959px) {
    .d-card-view {
        padding-left: 0 !important;
        padding-right: 3px !important;
    }
    .d-card-views3{
        padding-left: 0 !important;
    }
    :deep(.apexcharts-datalabels text){
        font-size: 11px !important;
    }
}

@media (min-width: 561px) and (max-width: 750px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 8.5px !important;
        font-weight: bold !important;
    }

}

@media (min-width: 522px) and (max-width: 561px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 7px !important;
        font-weight: bold !important;
    }
}

@media (min-width: 430px) and (max-width: 522px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 6px !important;
        font-weight: bold !important;
    }
}
@media (min-width: 300px) and (max-width: 430px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 5px !important;
        font-weight: bold !important;
    }
}
:deep(.apexcharts-datalabels text) {
  font-weight: bold !important;
  white-space: nowrap !important;
}

</style>